import React from "react";
import styled from "styled-components";
import { CaptionSemiboldStyle } from "../../Typography";
import CaveatLabel from "./CaveatLabel";

import theme from "../../../styles/theme";

const StyledLink = styled.a`
  ${CaptionSemiboldStyle};
  line-height: 100%;
  cursor: pointer;
  color: ${() => theme.colors.green5};
  transition: color 250ms ease-in-out 0s;
  text-decoration: none;
  margin-right: 20px;
  font-family: 'Graphik', 'Graphik Web', 'Helvetica Neue',Helvetica,Arial,sans-serif;
  &:hover {
    color: ${() => theme.colors.green3};
  }
`;

const SmallLink = ({ children, href, className, beta }) => {
  return (
    <StyledLink className={className} href={href}>
      {children}
      {beta && <CaveatLabel>BETA</CaveatLabel>}
    </StyledLink>
  );
};

export default SmallLink;
